@import 'src/styles/common/_colors.scss';

.container,.rangeInput{
  display: flex ;
  justify-content:space-between;
  align-items:center;
}
.container{
  flex-direction: column ;
}
.rangeInput{
  padding: 20px;
}

.container_slider {
  padding-top: 40px;
  height: 50px;
  margin-bottom: 40px;
  }
  
  .slider {
    position: relative;
    width: 200px;
  }
  
  .slider__track,
  .slider__range,
  .slider__left_value,
  .slider__right_value {
    position: absolute;
  }
  
  .slider__track,
  .slider__range {
    border-radius: 3px;
    height: 5px;
  }
  
  .slider__track {
    background: #161616;
    box-shadow: inset 2px 2px 5px;
    width: 100%;
    z-index: 1;
  }
  
  .slider__range {
    background: $dialog-background-color;
    box-shadow: inset 2px 2px 5px;
    z-index: 2;
  }
  
  .slider__left-value,
  .slider__right-value {
    font-size: 12px;
    margin-top: 20px;
  }
  
  .slider__left_value {
    top: -40px;
    color: $smoke-white;
  }
  
  .slider__right_value {
    right: -2px;
    top: -40px;
    color: $smoke-white;
  }

  .range_span{
    margin-left:10px;
    margin-right:10px;
  }
  .bubble{
    position: absolute;
    top: 148px;
    left: 33px;
  }
  
  /* Removing the default appearance */
  .thumb,
  .thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  
  .thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 200px;
    outline:$black
  }
  
  .thumb__zindex_3 {
    z-index: 3;
  }
  
  .thumb__zindex_4 {
    z-index: 4;
  }
  
  .thumb__zindex5 {
    z-index: 5;
  }
  
  /* For Chrome browsers */
  .thumb::-webkit-slider-thumb {
    cursor: pointer;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
	  width: 22px;
	  height: 22px;
	  background-color: $orientation-icon-color;
	  z-index: 2;
	  border-radius: 1em/1em;
    border: 7px solid $white;
    &:hover{
        background-color: $black;
    }
    &:active{
        background-color: $light-red;
    }
  }

  
  
  /* For Firefox browsers */
  .thumb::-moz-range-thumb {
    cursor: pointer;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
	  width: 22px;
	  height: 22px;
	  background-color: $orientation-icon-color;
	  z-index: 2;
	  border-radius: 1em/1em;
    border: 7px solid $white;
    &:hover{
        background-color: $black;
    }
    &:active{
        background-color: $light-red;
    }
  }

  .numberInput {
     box-shadow: inset 0 0 15px 0 $black;
     background: transparent;
     margin-bottom: 0;
     border-radius: 10px;
     border-color: $black;
     border-style: solid;
     border-width: 3px;
     font-size: 12px;
     font-weight: 600;
     color: $white;
     width: 70px;
     height: 29px;
     text-align: center;
     outline: 0;		
    &.inputActive{
      color: $white;
      background-color: $dark-green;
      box-shadow: initial;
    }
    &:focus {
      background-color: $white;
      box-shadow: inset 0 0 3px 0 $green-variant-2;
      outline: 0;
      border: 3px solid $green-variant-2;
      color: $black;
    }
  }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
  